'use client'

import { TravelPointQuoteWithAddressId } from '@repo/sdk'
import {
  AddressBook,
  DateTimeInput,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  Input,
} from '@repo/ui'
import { cn } from '@repo/ui/lib'
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form'

export const DropFieldsList = () => {
  const { control } = useFormContext<{ drops: TravelPointQuoteWithAddressId[] }>()

  const { fields } = useFieldArray({
    control,
    name: 'drops',
  })

  const stopHeader = (index: number) => {
    if (index === 0) {
      return 'Collection'
    }

    if (index === fields.length - 1) {
      return 'Delivery'
    }

    return `Stop #${index + 1}`
  }

  return (
    <div className={'flex w-full gap-4'}>
      {fields.map((field, index) => (
        <DropFields header={stopHeader(index)} index={index} key={field.id} />
      ))}
    </div>
  )
}

const DropFields = ({ header, index }: { header?: string; index: number }) => {
  const { control } = useFormContext<{ drops: TravelPointQuoteWithAddressId[] }>()

  const drop = useWatch({ control, name: `drops.${index}` })

  return (
    <div
      className={cn('flex flex-col gap-2', 'border-r pr-4', 'last:border-r-0 last:pr-0', 'w-full')}
    >
      <div className={'flex items-center gap-2'}>
        <p>{header}</p>
        {/*todo consider opening in a portal so that it will be outside of the form*/}
        <AddressBook index={index} />
      </div>
      <FormField
        control={control}
        name={`drops.${index}.place.name`}
        render={({ field }) => (
          <FormItem>
            <FormLabel className="dark:text-popover-foreground">Company name</FormLabel>
            <FormControl>
              <Input {...field} value={drop?.place?.name} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`drops.${index}.place.place_name`}
        render={({ field }) => (
          <FormItem>
            <FormLabel className="dark:text-popover-foreground">Street Address</FormLabel>
            <FormControl>
              <Input {...field} value={drop?.place?.place_name} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`drops.${index}.place.city`}
        render={({ field }) => (
          <FormItem>
            <FormLabel className="dark:text-popover-foreground">City</FormLabel>
            <FormControl>
              <Input {...field} value={drop?.place?.city} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`drops.${index}.place.postcode`}
        render={({ field }) => (
          <FormItem>
            <FormLabel className="dark:text-popover-foreground">Post code</FormLabel>
            <FormControl>
              <Input {...field} value={drop?.place?.postcode} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormItem>
        <FormLabel className="dark:text-popover-foreground">Date and time</FormLabel>
        <FormControl>
          <DateTimeInput className={'w-full'} control={control} index={index} isAdmin />
        </FormControl>
      </FormItem>
    </div>
  )
}
